function c(t, r) {
  var u, e, m;
  const n = ((u = t.minimumOrderDifferenceAmount) == null ? void 0 : u.amount) ?? 0, o = ((e = t.totalAmount) == null ? void 0 : e.amount) ?? 0;
  return {
    amount: (n > 0 ? o + n : o) + (r ?? 0),
    currency: (m = t.totalAmount) == null ? void 0 : m.currency
  };
}
export {
  c as default
};
